import { ChangeDetectionStrategy, Component, computed, Input, signal } from '@angular/core';

@Component({
  selector: 'app-issue-view-sidebar-wrapper',
  template: `
    <lib-sidebar-wrapper
      label="Vorgang"
      [entityRoute]="entityRoute()">
      <app-issue-view [showBreadcrumb]="false" />
    </lib-sidebar-wrapper>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IssueViewV2SidebarWrapperComponent {
  private readonly _issueId = signal<string>('');

  @Input()
  set issueId(value: string) {
    this._issueId.set(value);
  }

  readonly entityRoute = computed(() => ['issues', 'issue', this._issueId()]);
}
